import { EventBus } from '@/store/EventBus.js'
import methods from './methods.js'
import Vue from 'vue'

const getInitialState = () => {
  return { sopheo: {} }
}

export const API = {
  sopheo: 'sopheo'
}

const state = getInitialState()

const getters = {
  getAuthorization: state => api => {
    let authorization = ''
    api = api || Object.keys(state)[0]
    if (api === API.CkExpress) {
      authorization = `Bearer ${window.getCookie('token')}`
    } else {
      authorization = state[api] ? state[api].Authorization : ''
    }
    return authorization || ''
  },
  getBaseUrl: state => api => {
    api = api || Object.keys(state)[0]
    let url = state[api] ? state[api].UrlEndPoint : ''
    if (url && url.slice(-1) === '/') url = url.slice(0, -1)
    return url || ''
  },
  getRootUrl: (state, getters) => api => {
    let url = getters['getBaseUrl'](api)
    if (url) url = url.replace('/api', '')
    return url || ''
  },
  getPath: state => (api, controller) => {
    let path = ''
    controller = controller.split('.')
    api = api || Object.keys(state)[0]
    if (state[api] && state[api].Paths) {
      path = state[api].Paths[controller[0]]
      if (path && controller[1]) path = path[controller[1]]
    }
    if (path && path.toString().charAt(0) !== '/') path = '/' + path
    return path || ''
  },
  getUrl: (state, getters) => (api, controller) => {
    let url
    if (controller) {
      url = getters['getBaseUrl'](api)
      if (url && url.slice(-1) === '/') url = url.slice(0, -1)
      url += getters['getPath'](api, controller)
    }
    return url && url !== 'undefined' ? url : ''
  }
}

const actions = {
  async INIT_CONFIG ({ dispatch }) {
    try {
      await getConfig().then(async config => {
        if (!config) return
        let configApi = config[window.location.hostname] || config['default']
        getLocalUserIP(ip => console.info('Local IP: ' + ip.trim()))
        let ip = await getPublicUserIP()
        console.info('Public IP: ' + ip)

        if (configApi) {
          for (const [key, value] of Object.entries(methods)) {
            if (!configApi[key]) configApi[key] = {}
            if (configApi[key].public && ip) {
              if (configApi[key].public[ip]) configApi[key].UrlEndPoint = configApi[key].public[ip]
              delete configApi[key].public
            }
            Object.assign(configApi[key], value || {})
            dispatch('SET_CONFIG', { api: key, configApi: configApi[key] })
          }
        } else {
          alert('Error in configuration file')
        }
      })
    } catch (e) {
      alert('Error reading configuration file')
      console.error('Error reading configuration file', e)
    }
    EventBus.$emit('configLoad')
  },
  SET_CONFIG: ({ state, commit }, { api, configApi }) => {
    if (configApi) {
      if (!state[api]) state[api] = {}
      commit('SET_CONFIG', { api, configApi })
    }
  },
  RESET: ({ commit }) => {
    commit('RESET')
  }
}

const mutations = {
  SET_CONFIG: (state, { api, configApi }) => {
    if (configApi) {
      let merged = Object.assign({}, state[api] || {}, configApi || {})
      Vue.set(state, api, merged)
    }
  },
  RESET (state) {
    Object.keys(state).forEach(key => {
      if (typeof getInitialState()[key] === 'undefined') delete state[key]
    })
    Object.assign(state, getInitialState())
  }
}

export default {
  namespaced: true,
  initialState: state,
  state: Object.assign({}, state),
  getters,
  actions,
  mutations
}

async function getConfig () {
  const FETCH_TIMEOUT = 5000
  let didTimeOut = false
  let config = null
  try {
    await new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        didTimeOut = true
        reject(new Error('Request timed out'))
      }, FETCH_TIMEOUT)
      fetch('config.json?' + Date.now())
        .then(response => {
          clearTimeout(timeout)
          if (!didTimeOut) {
            response.json().then(json => {
              config = json
              resolve(response)
            })
          }
        })
        .catch(err => {
          if (didTimeOut) return
          reject(err)
        })
    })
      .then(() => {})
      .catch(err => console.error('C promise error! ', err))
  } catch (e) {
    console.error('Error on Get Public IP:', e)
  }
  return config
}

async function getPublicUserIP () {
  const FETCH_TIMEOUT = 5000
  let didTimeOut = false
  let ip

  try {
    await new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        didTimeOut = true
        reject(new Error('Request timed out'))
      }, FETCH_TIMEOUT)
      fetch('https://api.ipify.org?format=json')
        .then(response => {
          clearTimeout(timeout)
          if (!didTimeOut) {
            response.json().then(json => {
              ip = json.ip
              resolve(response)
            })
          }
        })
        .catch(err => {
          if (didTimeOut) return
          reject(err)
        })
    })
      .then(() => {})
      .catch(err => console.error('P promise error! ', err))
  } catch (e) {
    console.error('Error on Get Public IP:', e)
  }
  return ip
}

function getLocalUserIP (onNewIP) {
  /* eslint-disable new-cap */
  /* eslint-disable no-undef */
  function iterateIP (ip) {
    try {
      if (!localIPs[ip] && typeof onNewIP === 'function') onNewIP(ip)
      localIPs[ip] = true
    } catch (e) {
      console.error('Error on Get Local IP:', e)
    }
  }

  try {
    var myPeerConnection =
      window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
    var pc = new myPeerConnection({ iceServers: [] })
    var noop = function () {}
    var localIPs = {}
    var ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g
    pc.createDataChannel('')
    pc.createOffer(sdp => {
      sdp.sdp.split('\n').forEach(line => {
        if (line.indexOf('candidate') < 0) return
        line.match(ipRegex).forEach(iterateIP)
      })
      pc.setLocalDescription(sdp, noop, noop)
    }, noop)

    pc.onicecandidate = function (ice) {
      if (
        !ice ||
        !ice.candidate ||
        !ice.candidate.candidate ||
        !ice.candidate.candidate.match(ipRegex)
      ) {
        return
      }
      ice.candidate.candidate.match(ipRegex).forEach(iterateIP)
    }
  } catch (e) {
    console.error('Error on Get Local  IP:', e)
  }
}
